import DefaultLook from "./look";
import useDatePicker from "./use-date-picker";

const Simple = ({ look: Look = DefaultLook, ...props }) => {
  const processing = useDatePicker(props);
  return <Look {...props} processing={processing} />;
};

export default Simple;
